import { render, staticRenderFns } from "./AllCustomerCase.vue?vue&type=template&id=95f74238"
import script from "./AllCustomerCase.vue?vue&type=script&lang=js"
export * from "./AllCustomerCase.vue?vue&type=script&lang=js"
import style0 from "./AllCustomerCase.vue?vue&type=style&index=0&id=95f74238&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports